export default __webpack_public_path__ + "static/media/bump_black.b6e2eb8c.png";